import React from "react";
const IconRecent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16" {...props}>
    <circle cx="8.906" cy="8.002" r="6.4" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    <path d="M8.905 4.402v3.6l3.2 3.2" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
  </svg>
);
export default IconRecent;
